import {AfterViewInit, Component, ElementRef, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {
    MatCardModule,
} from "@angular/material/card";
import {MatError, MatFormField, MatLabel, MatSuffix} from "@angular/material/form-field";
import {MatInput, MatInputModule} from "@angular/material/input";
import {MatOption} from "@angular/material/autocomplete";
import {MatSelect} from "@angular/material/select";
import {DatePipe, NgClass, NgForOf, NgIf} from "@angular/common";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {Router, RouterLink} from "@angular/router";
import {MatButtonModule} from "@angular/material/button";
import {
    MatTableDataSource, MatTableModule
} from "@angular/material/table";
import {MatPaginator, MatPaginatorModule} from "@angular/material/paginator";
import {MatSort, MatSortModule} from "@angular/material/sort";
import {MatTooltipModule} from "@angular/material/tooltip";
import {OverlayContainer} from "@angular/cdk/overlay";
import {MatMenuModule} from "@angular/material/menu";
import {
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerModule,
    MatDatepickerToggle
} from "@angular/material/datepicker";

import {MatCheckbox} from "@angular/material/checkbox";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {ResultService} from "../../../../services/result-service/result.service";
import {UserService} from "../../../../services/user-service/user.service";
import {AnalyseResult, AnalyseService} from "../../../../services/analyse-service/analyse.service";
import {ApiService} from "../../../_services/api.service";
import {Endpoints} from "../../../endpoints";
import {DialogService} from "../../../_modal/dialog.service";
import {HandleErrorsService} from "../../../../services/handle-erros/handle.errors.service";
import {ExploitationService} from "../../../../services/exploitation-service/exploitation.service";
import {ClientsService} from "../../../../services/client-service/clients.service";
import {MatNativeDateModule} from "@angular/material/core";
import {ShortUserDTO} from "../../../_models/user.dtos";
import {CustomizerSettingsService} from "../../../../customizer-settings/customizer-settings.service";
import {environment} from "../../../../../environments/environment";
import { finalize } from 'rxjs';
import { MatIcon } from "@angular/material/icon";

@Component({
    selector: 'app-in-progress-analyses',
    providers: [ResultService, UserService, AnalyseService, ApiService, Endpoints, DialogService, HandleErrorsService, ExploitationService, ClientsService],
    standalone: true,
    imports: [FormsModule,
    MatDatepickerModule, MatNativeDateModule,
    DatePipe, MatCardModule, MatMenuModule, MatButtonModule, RouterLink, MatTableModule, MatPaginatorModule, NgIf,
    MatTooltipModule, ReactiveFormsModule, MatFormField, MatLabel, MatError, MatInput, MatDatepicker,
    MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatSortModule, MatInputModule, MatOption, MatSelect, NgForOf, MatCheckbox, MatProgressSpinner, NgClass, MatIcon],
    templateUrl: './validated-analyses.component.html',
    styleUrl: './validated-analyses.component.scss'
})
export class ValidatedAnalyse implements OnInit, AfterViewInit {
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('editModal') editModal: TemplateRef<AnalyseResult>;
    @ViewChild('viewModal') viewModal: TemplateRef<AnalyseResult>;
    @ViewChild('tableContainer', {static: false}) tableContainer!: ElementRef;

    searchValue: string = ''
    editForm: FormGroup;
    form: FormGroup;
    selectedAll: boolean = false
    selectedElements: Set<number> = new Set<number>()
    userList: ShortUserDTO[] = []
    analyse?: AnalyseResult
    dataSource = new MatTableDataSource<any>();
    displayedColumns: string[] = [
        'select',
        'ref',
        'sampleCode',
        'parameter',
        'startDate',
        'endDate',
        'sampleAnalyseRef',
        'dateMesure',
        'formule',
        'poids',
        'resultatBrute',
        'valide',
        'commentaire',
        'resultatFinale',
        'action'];
    loadingTable: boolean = false;
    loadingCalBtn: boolean = false;
    editedItems: Set<AnalyseResult> = new Set<AnalyseResult>()

    constructor(
        private analyseService: AnalyseService,
        private userService: UserService,
        private router:Router,
        private handleErrors: HandleErrorsService,
        private dialogService: DialogService,
        private fb: FormBuilder,
        private modalService: NgbModal,
        public themeService: CustomizerSettingsService,
        private overlayContainer: OverlayContainer) {
        this.initializeEditForm();
        this.initializeCreateForm()
    }

    ngOnInit(): void {
        this.loadingTable = true;
        this.fetchAnalyseList()
    }

    // Attributs
calculableSamples: any[] = [];
selectedSample: any;openSampleDetailsModal(sample: any, modalTemplate: TemplateRef<any>) {
  console.log('🔹 Sample sélectionné pour détails :', sample);

  // Comme on a déjà les analyses dans sample.analyses, on les utilise directement
  this.selectedSample = sample;

  // Ouvre le modal
  this.modalService.open(modalTemplate, { size: 'xl', ariaLabelledBy: 'modal-basic-title' });
}


toggleSelectAll(event: any) {
  this.selectedAll = event.checked;
  this.calculableSamples.forEach(s => s.selected = this.selectedAll);
}

onSelectElement(element: any) {
  this.selectedAll = this.calculableSamples.every(s => s.selected);
}

    formatDateTimeLocal(date: string | null): string | null {
    if (!date) return null;

    const d = new Date(date);
    const pad = (n: number) => n.toString().padStart(2, '0');

    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
    }

fetchAnalyseList(): void {
  console.log("🚀 fetchAnalyseList called");

  this.loadingTable = true;

  this.analyseService.getAnalyseResultsByStatut('VALIDE')
    .pipe(finalize(() => this.loadingTable = false))
    .subscribe({
      next: (results: any[]) => {
        console.log('📥 Données reçues (VALIDE) :', results);

        // Créer une map pour grouper par sampleId
        const groupedSamplesMap = new Map<number, any>();

        results.forEach(res => {
          const sampleId = res.sampleId;
          if (!sampleId) return;

          if (!groupedSamplesMap.has(sampleId)) {
            groupedSamplesMap.set(sampleId, {
              id: sampleId,
              endDate:res.endDate,
              startDate:res.startDate,
              code: res.sampleCode,
              clientName: res.clientName || 'N/A',
              sampleAnalyseRef: res.sampleAnalyseRef,
              statut: res.statut,
              dateAnalyse: res.dateMesure || res.startDate,
              resultsCount: 1,
              analyses: [res] // stocke les analyses dans un tableau
            });
          } else {
            const sample = groupedSamplesMap.get(sampleId);
            sample.resultsCount++;
            sample.analyses.push(res);
          }
        });

        // Convertir Map en tableau pour la table
        this.calculableSamples = Array.from(groupedSamplesMap.values());
        console.log('📊 Samples regroupés :', this.calculableSamples);

        // Mettre à jour le datasource de la table
        this.dataSource.data = this.calculableSamples;
      },
      error: (err) => console.error('❌ Erreur chargement VALIDE :', err)
    });
}

    
    /*fetchAnalyseList() {
        this.analyseService.findAllValidatedAnalyses().subscribe(
            {
                next: response => {
                    if (response.status) {
                        this.dataSource.data = response.data
                        this.fetchUsers()
                    }
                    this.loadingTable = true;
                },
                error: err => {
                    this.handleErrors.catchError(err)
                    this.loadingTable = false;
                },
                complete: () => this.loadingTable = false
            }
        )
    }*/

    fetchUsers() {
        this.userService.getUsers().subscribe({
            next: res => {
                if (res.status) {
                    this.userList = res.data
                }
            }
        })
    }

    ngAfterViewInit() {
        this.initializePaginatorAndSort();
    }

    initializePaginatorAndSort() {
        this.dataSource.filter = this.searchValue
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.sort.active = 'id';
        this.sort.direction = 'asc';
        const overlayContainerElement = this.overlayContainer.getContainerElement();
        overlayContainerElement.style.zIndex = '2000';
    }

    initializeEditForm() {
        this.editForm = this.fb.group({
            id: ['', Validators.required],
            refAnalyse: ['', Validators.required],
            startDate: ['', Validators.required],
            sampleAnalyseRef: ['', Validators.required],
            endDate: ['', Validators.required],
            creationDate: ['', Validators.required],
            status: [null, Validators.required],
            commentaire: ['', Validators.required],
            sampleId: [null, Validators.required],
            sampleCode: ['', Validators.required],
            parameterId: [null, Validators.required],
            parameterName: ['',],
            userId: [null, Validators.required],
            resultId: [null, Validators.required],
            poids: ['', Validators.required],
            resultat: ['', Validators.required],
            resultatFinale: ['', Validators.required],
            userName: ['',],
        });
    }

    initializeCreateForm() {
        this.form = this.fb.group({
            userId: ['', Validators.required]
        });
    }

    affectUser(): void {
        if (this.form.valid) {
            let params: number[]
            params = [this.form.value.userId, ...this.selectedElements]
            this.analyseService.affectUser(params).subscribe(
                {
                    next: response => {
                        if (response.status) {
                            this.fetchAnalyseList()
                            this.modalService.dismissAll();
                            this.dialogService.openSuccessDialog(response.message)
                            this.selectedAll = false
                        }
                    },
                    error: err => this.handleErrors.catchError(err),
                    complete: () => this.form.reset()
                }
            )
        } else {
            this.dialogService.open('Bad Request. Please Check Your Input and Submit Again!', environment.error_message_type, 'danger', environment.error_icon).finally();
        }
    }

    openEditModal(element: AnalyseResult) {
        this.editForm.patchValue(element);
        console.log(element)
        this.modalService.open(this.editModal, {ariaLabelledBy: 'modal-basic-title', size: 'lg'});
    }

    openModal(content: any) {
        this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', size: 'sm'})
    }

    openViewModel(element: AnalyseResult) {
        this.analyse = element
        this.modalService.open(this.viewModal, {ariaLabelledBy: 'modal-basic-title', size: 'lg'});
    }

    updateTableRow(analyseDTO: AnalyseResult) {
        const index = this.dataSource.data.findIndex(item => item.id === analyseDTO.id);
        if (index !== -1) {
            this.dataSource.data[index] = analyseDTO;
            this.dataSource = new MatTableDataSource<any>(this.dataSource.data);
        }
    }

    confirmDelete(id: number) {
        this.dialogService.open('Etes-vous sûr de vouloir supprimer cet élément ?', environment.warning_message_type, 'danger', environment.warning_icon, true)
            .then((result: any) => {
                if (result) {
                    this.deleteAnalyse(id);
                }
            });
    }

    private deleteAnalyse(id: number) {
        this.analyseService.delete(id).subscribe({
            next: response => {
                if (response.status) {
                    this.dataSource.data = this.dataSource.data.filter(item => item.id != id)
                    this.dialogService.openSuceessAlert(response.message);

                } else {
                    this.dialogService.open(response.message, environment.error_message_type, 'danger', environment.error_icon).finally();

                }
            }, error: err => this.handleErrors.catchError(err),
        })
    }

    applyFilter(event: Event) {
        this.searchValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
        this.dataSource.filter = this.searchValue;
    }

    updateAnalyse(element: AnalyseResult) {
        this.analyseService.updateE(element).subscribe({
            next: response => {
                if (response.status) {
                    this.updateTableRow(response.data)
                    this.modalService.dismissAll();
                    this.dialogService.openSuccessDialog(response.message);
                } else {
                    this.dialogService.openDangerDialog(response.message);
                }
            },
            error: err => this.handleErrors.catchError(err),
            complete: () => {
                this.initializePaginatorAndSort();
            }
        });
    }

    handleChecked(element: AnalyseResult) {
        if (this.selectedElements.has(element.id)) {
            this.selectedElements.delete(element.id)
        } else {
            this.selectedElements.add(element.id)
        }
    }

    handleSelectAll() {
        this.selectedAll = !this.selectedAll
        if (this.selectedAll)
            this.selectedElements = new Set<number>(this.dataSource.data.map(element => element.id))
        else
            this.selectedElements = new Set<number>()
    }

    navigateInputs(event: KeyboardEvent, index: number, column: string): void {
        const columns = ['ref', 'sampleCode', 'parameter', 'status','sampleAnalyseRef', 'startDate', 'endDate', 'poids', 'resultat', 'resultatFinale', 'commentaire']; // Add all columns with inputs here
        const columnIndex = columns.indexOf(column);

        switch (event.key) {
            case 'Enter':
            case 'ArrowDown':
                const nextRow = document.getElementById(`${column}${index + 1}`);
                if (nextRow) nextRow.focus();
                event.preventDefault();
                break;

            case 'ArrowUp':
                // Move to the input above, if it exists
                const previousRow = document.getElementById(`${column}${index - 1}`);
                if (previousRow) previousRow.focus();
                event.preventDefault();
                break;

            case 'ArrowRight':
                if (columnIndex < columns.length - 1) {
                    // Move to the next column in the same row
                    const nextColumn = document.getElementById(`${columns[columnIndex + 1]}${index}`);
                    if (nextColumn) nextColumn.focus();
                    event.preventDefault();
                }
                break;

            case 'ArrowLeft':
                if (columnIndex > 0) {
                    // Move to the previous column in the same row
                    const previousColumn = document.getElementById(`${columns[columnIndex - 1]}${index}`);
                    if (previousColumn) previousColumn.focus();
                    event.preventDefault();
                }
                break;
        }
    }

    calculerMultipleResult() {
        if (this.editedItems.size == 0) {
            this.dialogService.openDangerDialog("Veuillez sélectionner au moins un element.")
            return
        }
        this.loadingCalBtn = true
        const dtos: AnalyseResult[] = [...this.editedItems]
        setTimeout(()=>  this.analyseService.calculerMultipleResult(dtos).subscribe({
            next: response => {
                if (response.status) {
                    this.dataSource.data = response.data
                    this.modalService.dismissAll()
                    this.dialogService.openSuccessDialog("Les résultats finaux ont été mis à jour avec succès.")
                }
            },
            error: err => {
                this.handleErrors.catchError(err)
                this.editedItems = new Set<AnalyseResult>()
                this.loadingCalBtn = false
            },
            complete: () => {
                this.editedItems = new Set<AnalyseResult>()
                this.loadingCalBtn = false
            }
        }),1200)

    }

    addResult(element: AnalyseResult) {
        console.log('Element avant ajout:', element);
    
        if (element.commentaire) {
            this.editedItems.add({...element}); 
            this.fetchAnalyseList();// Crée une copie de l'élément avec la nouvelle valeur
        }
    
        console.log('Éléments modifiés:', this.editedItems);
    }
    
    
}

